import { createLogic } from 'redux-logic'
import handleErrors from '@app/helpers/handleErrors'
import { PATCH_ZWAVE_DEVICE_STATUS } from '@app/constants/myDevices/zwaveDevices'
import { API_REQUEST_CANCEL } from '@app/constants/apiRequest'
import { apiRequestDone, apiRequestFailed, apiRequestSent } from '@app/actions/apiRequest'
import Api from '@app/api/myDevices/deviceSettings/zwaveDevices'

const patchZwaveDeviceStatusLogic = createLogic({
  type: PATCH_ZWAVE_DEVICE_STATUS,
  latest: true,
  cancelType: API_REQUEST_CANCEL,

  transform({ getState, action }, next) {
    const { secrets: { accessToken: { token } } } = getState()
    next({
      ...action,
      token,
    })
  },

  async process({ action }, dispatch, done) {
    dispatch(apiRequestSent(PATCH_ZWAVE_DEVICE_STATUS))
    try {
      await Api.patchZwaveDeviceStatus(action.token, action.data.id, action.data)
      dispatch(apiRequestDone(PATCH_ZWAVE_DEVICE_STATUS))
    } catch (error) {
      if (error) {
        const currentError = handleErrors(error)
        dispatch(apiRequestFailed(currentError))
      } else {
        throw new Error('PATCH_ZWAVE_DEVICE_STATUS failed without error')
      }
    }
    done()
  },
})

export default patchZwaveDeviceStatusLogic
